import authReducer from './reducers/auth.Reducer';
import webConfigReducer from './reducers/webConfig.Reducer';
import menuTypeServiceReducer from './reducers/menuTypeService.Reducer';
import productsReducer from '../redux-store/reducers/products.Reducer';
import orderReducer from '../redux-store/reducers/order.Reducer';
import tableReservationReducer from '../redux-store/reducers/tableReservation.Reducer';
import membershipPlanReducer from '../redux-store/reducers/membership.Reducer';
import rewardPointReducer from '../redux-store/reducers/rewardPoint.Reducer';
import notificationReducer from '../redux-store/reducers/notification.Reducer';

export default {
    authReducer,
    webConfigReducer,
    menuTypeServiceReducer,
    productsReducer,
    orderReducer,
    tableReservationReducer,
    membershipPlanReducer,
    rewardPointReducer,
    notificationReducer
}